import React from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import SubscriptionSwitcher from 'subscriptions/SubscriptionSwitcher';
import Box from 'common/Box';
import Link from 'common/Link';
import InsuranceLink from 'insurance/Link';
import * as routes from 'app/routes';
import { getQuickSubscription } from 'reducers'
import add_green_circle from 'common/img/add_green_circle.svg';
import styles from './Subscription.module.css';

export const SubscriptionScreen = ({ subId, sub }) => {
  return (
    <div className={cn('Subscription', styles.wrapper)}>
      <SubscriptionSwitcher
        quickSubId={subId}
        quickRoute={routes.quickSubscription}
        bypassedRoute={routes.bypassedSubscription}
        sprintRoute={routes.sprintSubscription}
      />
      <div className={styles.linkList}>
        {sub && (
          <Link className={styles.subscriptionLink} to={routes.quickAddData(subId)}>
            <Box>
              <img src={add_green_circle} />
              Add Data
            </Box>
          </Link>
        )}
        <InsuranceLink className={styles.subscriptionLink} quickSubId={subId} />
      </div>
    </div>
  )
}

const mapStateToProps = (state, { subId }) => ({
  sub: getQuickSubscription(state, subId),
})

export default connect(mapStateToProps, null)(SubscriptionScreen);
